import React from 'react';
import logo from '../../svg/logo-unilever.svg';

const Header = (props) => (
    <div className="react-header">
        <header>
            <img className="logo" src={logo} alt="Logo CompraUnilever"/>
        </header>
        <ul className="banner-lists fullWidth">
            <div className="centerAll">
                <li className="banner-item">
                    <p className="title-list">Listas Sugeridas</p>
                    <p className="desc-list">Edite, crie e organize suas listas sem complicação</p>
                </li>
            </div>
        </ul>

        <div className="header-tools">
            <div onClick={props.undo} className={props.hasUndo ? 'tool' : 'tool disabled'}><i className="fa fa-undo"></i><p>Undo</p></div>
            <div onClick={props.togglePreviewMode} className={props.isPreviewMode ? 'tool preview-active' : (props.hasList ? 'tool' : 'tool disabled')}><i className="fa fa-eye"></i><p>Preview</p></div>
            <div onClick={props.importListaSugerida} className="tool"><i className="fa fa-code"></i><p>Import</p></div>
            <div onClick={props.exportListaSugerida} className={props.hasList ? 'tool' : 'tool disabled'}><i className="fa fa-save"></i><p>Export</p></div>

            <div className="clearfix"></div>
        </div>

        {!props.hasList &&
            <p className="no-list-imported">Clique em "Import" para importar o JSON da lista sugerida</p>
        }
    </div>
)

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js